import React from "react";
import PropTypes from "prop-types";
import Ripple from "./Ripple";

const Loader = ({ size, shouldHideText }) => {
  const side = size === "small" ? 50 : 100;
  const strokePercentage = 0.15;
  const radius = (side * (1 - strokePercentage)) / 2;
  const strokeWidth = (side * strokePercentage) / 2;

  return (
    <div className={`tw-text-center ${size === "small" ? "" : "tw-my-6"}`}>
      <div className="tw-mx-auto tw-inline-block">
        <svg width={side} height={side}>
          <Ripple
            radius={radius}
            strokeWidth={strokeWidth}
            className="tw-text-primary tw-stroke-current anim-delay-1000"
          />
          <Ripple
            radius={radius}
            strokeWidth={strokeWidth}
            className="tw-text-gray-600 tw-stroke-current"
          />
        </svg>
      </div>

      {!shouldHideText ? (
        <div
          className={`tw-text-center tw-text-coolGray-500 tw-font-hairline ${
            size === "small" ? "tw-text-lg" : "tw-text-xl"
          }`}
        >
          Loading, please wait...
        </div>
      ) : null}
    </div>
  );
};

Loader.propTypes = {
  size: PropTypes.oneOf(["small", "small-loader"]),
  shouldHideText: PropTypes.bool,
};
Loader.defaultProps = {
  size: null,
  shouldHideText: false,
};

export default Loader;
